const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/branded_apps_builder_landing_page.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { checkIsBrandedAppsBuilderUIEnabled } from "@/react/hooks/useBrandedAppsFeatureFlags";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/branded_apps_builder_landing_page")({
  beforeLoad: ({
    context
  }) => {
    const isBuilderEnabled = checkIsBrandedAppsBuilderUIEnabled(context.punditUserContext?.currentCommunity);
    if (isBuilderEnabled) {
      redirect({
        to: settingsNavPathV3.plus.index,
        replace: true,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});